module.exports = __webpack_public_path__ + "media/images/cuisinière-686071f7c2bfa03358b2f17966688781.svg";